module.exports = __webpack_public_path__ + "static/media/muscle_back_20.c5987e13.png";